import { ProcesName } from './ProcesHandlerHelpers';
import { ProcesHandler } from '../../interfaces/FormConfig';
import { FormProps, FormState } from '../FormContainer';
import { IntakeService } from "../../services/IntakeService";

export class IntakeProcessHandlerHelpers {
    static getProcesses(): ProcesHandler[] {
        return [
            
            {
                // PUT when done
                procesName: ProcesName.Put_postprocess_Success,
                execute: (
                    component: React.Component<FormProps, FormState>,
                    data: any,
                    onSuccess,
                    onError
                ) => {
                  IntakeService.setAnswer("");
                  IntakeService.setQuestion("");
                  onSuccess(data);                                                                          
                }
            }
        ];
    }
}
